import { gql } from '@apollo/client';

export const CONTENT_EDIT_ITEM = gql`
  query getNdPageEditItem($input: NdPageContentInput!) {
    getNdPageEditItem(input: $input) {
      id
      type_data {
        type
        title
        edit_image
        edit_ingress
        edit_text
      }
      title
      ingress
      content
      image
    }
  }
`;